import { useEffect, useState } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import IBAN from 'iban';

const IbanManage = ({ adherentId, closeIbanManage }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');

    const [adherent, setAdherent] = useState({ adherentId, bic: '', iban: '' });

    const [formattedIBAN, setFormattedIBAN] = useState('');


    const getIban = () => {
        fetch(`${url}GetIban/${adherentId}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                let iban = data.data[0];
                console.log('iban:', iban);
                setAdherent({ adherentId, bic: iban.bic, iban: iban.iban });
                setFormattedIBAN(IBAN.printFormat(iban.iban));
            })
            .catch(error => console.error('Erreur:', error));
    }

    useEffect(() => {
        getIban();
    }, []);

    const handleSaveIban = () => {
        //[HttpGet("UpdateIban/{id}/{iban}/{bic}/{code}")]
        fetch(`${url}UpdateIban/${adherentId}/${adherent.iban}/${adherent.bic}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                closeIbanManage();
            })
            .catch(error => console.error('Erreur:', error));
    }

    const isValidBICNumber = (input) => {
        var res = /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(input.toUpperCase());
        return res;
    }

    //https://stackoverflow.com/questions/21928083/iban-validation-check
    const isValidIBANNumber = (input) => {
        var CODE_LENGTHS = {
            AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
            CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
            FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
            HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
            LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
            MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
            RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
        };
        var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
        // check syntax and length
        if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
            return false;
        }
        // rearrange country code and check digits, and convert chars to ints

        digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
            var res = letter.charCodeAt(0) - 55;
            return res.toString();
        });

        // digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        //     return letter.charCodeAt(0) - 55;
        // });
        // final check
        return mod97(digits) === 1;
    }

    const mod97 = (string) => {
        var checksum = string.slice(0, 2), fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }

    const handleInputChange = (field, value) => {
        setAdherent({ ...adherent, [field]: value });
    };

    return (
        <div>
            <InputGroup className={`mb-3 ${adherent.iban.length === 0 ? 'has-error' : ''}`}>
                <InputGroup.Text className={isValidIBANNumber(adherent.iban) ? '' : 'border-danger'}>
                    IBAN<span style={{ color: 'red' }}>&nbsp;*</span>
                </InputGroup.Text>
                <FormControl
                    value={formattedIBAN}
                    onChange={(e) => {
                        const inputIBAN = e.target.value;
                        setFormattedIBAN(IBAN.printFormat(inputIBAN));
                        // Vérifiez si l'IBAN entré est valide avant de le mettre à jour
                        if (IBAN.isValid(inputIBAN)) {
                            handleInputChange('iban', inputIBAN);
                        } else {
                            handleInputChange('iban', '');
                        }
                    }}
                />
            </InputGroup>
            <InputGroup className={`mb-3 ${isValidBICNumber(adherent.bic) ? '' : 'has-error'}`}>
                <InputGroup.Text className={isValidBICNumber(adherent.bic) ? '' : 'border-danger'}>
                    BIC<span style={{ color: 'red' }}>&nbsp;*</span>
                </InputGroup.Text>
                <FormControl
                    value={adherent.bic}
                    onChange={(e) => handleInputChange('bic', e.target.value)}
                />
            </InputGroup>

            <div style={{ marginBottom: '10px' }}>
                {/* Add a message to inform that required fields are mandatory */}
                <p style={{ color: 'red' }}>Les champs marqués d'une * sont obligatoires.</p>
            </div>
            <div className="d-grid gap-2">
                <Button variant="primary" size='lg' onClick={handleSaveIban} disabled={!(isValidIBANNumber(adherent.iban) && isValidBICNumber(adherent.bic))}>Enregistrer</Button>
            </div>
        </div >
    );
}

export default IbanManage;


